/**
 * gift-wrap-cart-sync.js
 * Automatically synchronizes parent product quantities and removal
 * with associated gift wrap products in the cart.
 */

(function() {
  'use strict';

  let isSyncing = false;

  async function checkAndSyncCart(cart) {
    if (isSyncing) return;
    const items = cart.items || [];
    const groups = {};

    // Group items by _gift_group_id
    items.forEach((item) => {
      const properties = item.properties || {};
      const groupId = properties._gift_group_id;
      if (groupId) {
        if (!groups[groupId]) {
          groups[groupId] = {
            parent: null,
            giftWrap: null
          };
        }
        // Check if this item is a gift wrap product
        const isGiftWrap = properties._gift_wrap === 'true' || properties._gift_wrap === true;
        if (isGiftWrap) {
          groups[groupId].giftWrap = item;
        } else {
          groups[groupId].parent = item;
        }
      }
    });

    const updates = {};
    let needsUpdate = false;

    for (const groupId in groups) {
      const { parent, giftWrap } = groups[groupId];

      if (giftWrap) {
        if (!parent) {
          // Parent item was removed: remove the gift wrap item
          updates[giftWrap.key] = 0;
          needsUpdate = true;
        } else if (giftWrap.quantity !== parent.quantity) {
          // Quantities out of sync: synchronize gift wrap quantity to match parent quantity
          updates[giftWrap.key] = parent.quantity;
          needsUpdate = true;
        }
      }
    }

    if (needsUpdate) {
      isSyncing = true;

      // Determine active cart sections to render and update
      const sections = ['cart-icon-bubble'];
      if (document.querySelector('.drawer__inner')) {
        sections.push('cart-drawer');
      }
      if (document.querySelector('cart-items')) {
        sections.push('main-cart-items');
      }

      try {
        const response = await fetch(`${(window.routes && window.routes.cart_update_url) || '/cart/update.js'}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            updates,
            sections,
            sections_url: window.location.pathname
          })
        });
        const updatedCart = await response.json();

        // Update DOM for each section returned
        if (updatedCart.sections) {
          for (const sectionId in updatedCart.sections) {
            const html = updatedCart.sections[sectionId];
            if (!html) continue;

            if (sectionId === 'cart-drawer') {
              const drawerInner = document.querySelector('.drawer__inner');
              if (drawerInner) {
                const newInner = new DOMParser().parseFromString(html, 'text/html').querySelector('.drawer__inner');
                if (newInner) drawerInner.innerHTML = newInner.innerHTML;
              }
            } else if (sectionId === 'main-cart-items') {
              const cartItems = document.querySelector('cart-items');
              if (cartItems) {
                const newCartItems = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-items');
                if (newCartItems) cartItems.innerHTML = newCartItems.innerHTML;
              }
            } else if (sectionId === 'cart-icon-bubble') {
              const iconBubble = document.getElementById('cart-icon-bubble') || document.querySelector('#cart-icon-bubble');
              if (iconBubble) {
                const newBubble = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section') || new DOMParser().parseFromString(html, 'text/html').body.firstElementChild;
                if (newBubble) iconBubble.innerHTML = newBubble.innerHTML;
              }
            }
          }
        }
        
        // Broadcast the update using the theme's pubsub system to refresh the UI
        if (window.publish && window.PUB_SUB_EVENTS) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gift-wrap-sync' });
        }
        
        // Dispatch custom event to notify cart elements
        document.dispatchEvent(new CustomEvent('cart:change', {
          detail: {
            cart: updatedCart,
            source: 'gift-wrap-sync'
          }
        }));

        // Force reload if on the cart page to ensure totals/prices are correct (fallback)
        if (window.location.pathname === ((window.routes && window.routes.cart_url) || '/cart')) {
          window.location.reload();
        }
      } catch (e) {
        console.error('[GiftWrap Sync] Error during cart synchronization:', e);
      } finally {
        isSyncing = false;
      }
    }
  }

  function fetchAndSync() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        checkAndSyncCart(cart);
      })
      .catch(err => console.error('[GiftWrap Sync] Error fetching cart:', err));
  }

  // Listen to cart change events dispatched by the theme
  document.addEventListener('cart:change', (event) => {
    // Prevent infinite loops if the event was triggered by our own sync
    if (event.detail && event.detail.source === 'gift-wrap-sync') return;
    
    if (event.detail && event.detail.cart) {
      checkAndSyncCart(event.detail.cart);
    } else {
      fetchAndSync();
    }
  });

  // Verify synchronization status on initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fetchAndSync);
  } else {
    fetchAndSync();
  }
})();
